import { loadProduct } from "#lib/products/load.ts";
import type { PageLoad } from "./$types.ts";

export const ssr = true;

export const prerender = true;

export const load: PageLoad = loadProduct;
